export const FeaturesData = [
  {
    imageName: 'static/svg/cml/electric_truck.svg',
    description: 'Lightning fast deliveries'
  },
  {
    imageName: 'static/svg/cml/notebook_text.svg',
    description: 'Seamless handling and booking processes',
  },
  {
    imageName: 'static/svg/cml/store.svg',
    description: 'Shop items from top Chinese eCommerce stores'
  },
  {
    imageName: 'static/svg/cml/scan_line.svg',
    description: 'Enjoy priority focus on your convenience'
  },
];
